import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createSubscription } from './subscriptions.service'

export const useSubscriptionCreate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createSubscription,
    onSuccess: async (_, vars) => {
      await queryClient.invalidateQueries({
        queryKey: ['subscriptions', vars.entityId],
      })
    },
  })
}
